<app-header-title>
  <span title>{{'workSystemSetting.ExtraTimeRules'|translate}}</span>
</app-header-title>

<div class="publicsetting" style="padding: 0rem 3rem;">
  <dx-data-grid #grid class="dx-card wide-card" [dataSource]="customDataSource" #datagrid [showBorders]="false"
    [focusedRowEnabled]="true" [focusedRowIndex]="0" [columnAutoWidth]="true" [columnHidingEnabled]="true"
    [showColumnLines]="false" [rowAlternationEnabled]="true" [showRowLines]="false" [showBorders]="false"
    [errorRowEnabled]="false" [rtlEnabled]="currentLang=='ar'?true:false"
    (onEditorPreparing)="onEditorPreparing($event)" (onEditingStart)="extraform($event)"
    (onInitNewRow)="extraform($event)">

    <dxo-editing mode="popup" [useIcons]="false" [allowAdding]="true" [allowDeleting]="true" [allowUpdating]="true"
      [texts]="button">
      <dxo-popup title="{{'tableinfo.info'|translate}}" [showTitle]="true" [hideOnOutsideClick]="true">
      </dxo-popup>

      <dxo-texts [addRow]="addrowfun('workSystemSetting.ExtraTimeRules')"
        confirmDeleteMessage="{{'tableinfo.deletebutton'|translate}}">
      </dxo-texts>
    </dxo-editing>


<dxo-paging  [pageSize]="10"> </dxo-paging>    <dxo-pager [visible]="true" allowedPageSizes="true" displayMode="full" [showPageSizeSelector]="true"
      [showInfo]="false" [showNavigationButtons]="true">
    </dxo-pager>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxi-column dataField="nameAr" [width]="190" caption="{{'tableinfo.NameAr'|translate}}" [hidingPriority]="8">

      <dxi-validation-rule type="required" message="{{'errors.namerequired'|translate}}">
      </dxi-validation-rule>
      <dxi-validation-rule type="stringLength" [max]="50"
        message="{{'errors.NameLength' |translate}}"></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="nameEn" [visible]="false" caption="{{'tableinfo.NameEn'|translate}}" [hidingPriority]="6">
    </dxi-column>

    <dxi-column dataField="dateOfRegistration" [visible]="false" dataType="date" [allowEditing]="false"
      caption="{{'tableinfo.dateOfRegistration'|translate}}"></dxi-column>

    <dxi-column dataField="durationType" caption="{{'workSystemSetting.DeductionRules.Timing' |translate}}">
      <dxo-lookup [dataSource]="durationType" valueExpr="id" displayExpr="name"></dxo-lookup>
    </dxi-column>

    <dxi-column dataField="taxableStatus" caption="{{'tableinfo.status'|translate}}">
      <dxo-lookup [dataSource]="TaxableStatus" valueExpr="id" displayExpr="name"></dxo-lookup>
    </dxi-column>

    <dxi-column dataField="fromRule" caption="{{'tableinfo.from'|translate}}" dataType="number" [visible]="false">
      <dxi-validation-rule type="range" [min]="0" message="{{'errors.min'|translate}}">
      </dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="toRule" caption="{{'tableinfo.to'|translate}}" dataType="number" [visible]="false">
      <dxi-validation-rule type="range" [min]="fromvalue" message="{{'errors.greater'|translate}}">
      </dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="description" caption="{{'tableinfo.description'|translate}}" [visible]="false"></dxi-column>
    <dxi-column dataField="isActive" dataType="boolean" caption="{{'tableinfo.isActive'|translate}}">
    </dxi-column>

    <dxi-column type="buttons">
      <dxi-button name="edit" text="{{'tableinfo.editbutton'|translate}}"></dxi-button>
      <dxi-button name="delete" text="{{'tableinfo.removebutton'|translate}}"></dxi-button>
    </dxi-column>
    <dxo-remote-operations [groupPaging]="true">
    </dxo-remote-operations>
  </dx-data-grid>
</div>